import { contentVectorizationActions } from '../actions'

const {
  FETCH_CONTEUDO,
  FETCHING_CONTEUDO,
  FETCH_CONTEUDO_ERROR,
  FETCH_CONTEUDOS,
  FETCHING_CONTEUDOS,
  FETCH_CONTEUDOS_ERROR,
  OPEN_CONTEUDO_MODAL,
  CLOSE_CONTEUDO_MODAL,
  CHANGE_CONTEUDO,
  NEW_FORM_CONTEUDO,
  CONTEUDO_FORM_TOUCHED,
  ADD_CONTEUDO,
  DELETE_CONTEUDO,
  CHANGE_CONTEUDO_PAGE,
  CHANGE_CONTEUDO_PER_PAGE,
  CHANGE_CONTEUDO_TIPO_FILTER,
  RESET_CONTEUDO_STATE,
} = contentVectorizationActions

const initialState = {
  loadingConteudo: false,
  loadingConteudos: false,
  fetchConteudoError: false,
  fetchConteudosError: false,

  conteudos: [],

  conteudo: {
    tipo: '',
    titulo: '',
    content_id: '',
    autores: [],
    ano: null,
    especialidade: '',
    isbn: null,
    conteudoHtml: '',
    idVetor: null,
  },

  conteudoFormTouched: false,
  tipoFilter: '',

  pagination: {
    page: 0,
    rowsPerPage: 20,
    length: 0,
  },

  lastAcceptedContentId: null,
  lastAcceptedCycleUuid: null,

  modalOpen: false,
}

const contentVectorization = (state = initialState, action = {}) => {
  switch (action.type) {
    case OPEN_CONTEUDO_MODAL:
      return { ...state, modalOpen: true }

    case CLOSE_CONTEUDO_MODAL:
      return { ...state, modalOpen: false }

    case CHANGE_CONTEUDO:
      return { ...state, conteudo: action.conteudo }

    case NEW_FORM_CONTEUDO:
      return { ...state, conteudo: { ...initialState.conteudo }, conteudoFormTouched: false }

    case CONTEUDO_FORM_TOUCHED:
      return { ...state, conteudoFormTouched: true }

    case CHANGE_CONTEUDO_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.page } }

    case CHANGE_CONTEUDO_PER_PAGE:
      return { ...state, pagination: { ...state.pagination, rowsPerPage: action.perPage } }

    case CHANGE_CONTEUDO_TIPO_FILTER:
      return {
        ...state,
        tipoFilter: action.tipo,
        pagination: { ...state.pagination, page: 0 },
      }

    case FETCHING_CONTEUDO:
      return { ...state, loadingConteudo: true, fetchConteudoError: false }

    case FETCH_CONTEUDO_ERROR:
      return { ...state, loadingConteudo: false, fetchConteudoError: action.err }

    case FETCHING_CONTEUDOS:
      return { ...state, loadingConteudos: true, fetchConteudosError: false }

    case FETCH_CONTEUDOS:
      return {
        ...state,
        loadingConteudos: false,
        conteudos: action.conteudos,
        fetchConteudosError: false,
        pagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage,
        },
      }

    case FETCH_CONTEUDOS_ERROR:
      return {
        ...state,
        loadingConteudos: false,
        loadingConteudo: false,
        fetchConteudosError: action.err,
      }

    case ADD_CONTEUDO:
      return {
        ...state,
        loadingConteudo: false,
        fetchConteudoError: false,
        conteudos: [action.conteudo, ...state.conteudos],
        lastAcceptedContentId: action.contentId || null,
        lastAcceptedCycleUuid: action.cicloUuid || null,
      }

    case DELETE_CONTEUDO:
      return {
        ...state,
        loadingConteudos: false,
        conteudos: state.conteudos.filter((item) => item.content_id !== action.contentId),
      }

    case RESET_CONTEUDO_STATE:
      return initialState

    default:
      return state
  }
}

export default contentVectorization



// WEBPACK FOOTER //
// ./src/reducers/contentVectorization.js